import { push } from '@lagunovsky/redux-react-router'
import cx from 'classnames'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { formatDate } from '../../global/helpers'
import ButtonCinestar from '../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../Typography/Typography'
import OrderStepCircle from './components/OrderStepCircle/OrderStepCircle'
import { PAGE_NAME } from './constants'
import hocOrderStepsHeader from './hocOrderStepsHeader'

import './OrderStepsHeader.scss'

const OrderStepsHeader = ({
    isAuth,
    emptyBasket,
    text,
    active,
    eventid,
    site,
    onClickBack,
    onClickExtend,
    className,
    loading,
    isClubMember,
    isExpiring,
    cardValidity,
    selectedPayment,
    cardInBasket,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const referer = localStorage.getItem('referer')

    const lineClass = 'steps-line border-top opacity-50'

    const disableSecondStep = emptyBasket
    const disableThirdStep = emptyBasket || !selectedPayment
    const disableFourthStep = emptyBasket || !selectedPayment || !isAuth

    const expirationTextId = isClubMember ? 'userProfile.cardValidity' : 'userProfile.cardValidityExpired'

    return (
        <div className={cx('order-steps-header d-flex align-items-center w-100', className)}>
            <div className="w-25">
                <ButtonCinestar
                    variant={'secondary'}
                    iconLeft={'arrow-left'}
                    className={'order-steps-header--button'}
                    onClick={onClickBack}
                    disabled={loading}
                >
                    {intl.formatMessage({ id: 'buttons.back' })}
                </ButtonCinestar>
            </div>
            <div className={'order-steps-header--steps d-flex justify-content-center align-items-center mx-auto'}>
                <OrderStepCircle
                    number={1}
                    text={text}
                    active={active === PAGE_NAME.hall}
                    onClick={() => dispatch(push(`/?eventid=${eventid}&site=${site}&ref=${referer}`))}
                />
                <span className={lineClass} />
                <OrderStepCircle
                    number={2}
                    text={text}
                    active={active === PAGE_NAME.yourOrder}
                    onClick={() => dispatch(push(`/${PAGE_NAME.yourOrder}`))}
                    disable={disableSecondStep}
                />
                {!isAuth && (
                    <>
                        <span className={lineClass} />
                        <OrderStepCircle
                            number={3}
                            text={text}
                            active={active === PAGE_NAME.contactInfo}
                            onClick={() => dispatch(push(`/${PAGE_NAME.contactInfo}`))}
                            disable={disableThirdStep}
                        />
                    </>
                )}
                <span className={lineClass} />
                <OrderStepCircle
                    number={isAuth ? 3 : 4}
                    text={text}
                    active={active === PAGE_NAME.orderSummary}
                    onClick={() => dispatch(push(`/${PAGE_NAME.orderSummary}`))}
                    disable={disableFourthStep}
                />
            </div>
            <div className="order-steps-header--member w-25">
                {active === PAGE_NAME.orderSummary && isExpiring && (
                    <div className={'extend-membership d-flex align-items-center gap-3 text-nowrap'}>
                        <div className="d-flex flex-column text-end">
                            <Typography variant={'pLink'}>{intl.formatMessage({ id: expirationTextId })}</Typography>
                            <Typography variant={'desc'} color={'magentaSecondary'}>
                                {formatDate(cardValidity)}
                            </Typography>
                        </div>
                        {!cardInBasket && (
                            <ButtonCinestar variant={'primary-v1'} onClick={onClickExtend}>
                                {intl.formatMessage(
                                    { id: 'buttons.extendMembership' },
                                    { span: (chunks) => <span className="non-mobile">{chunks}</span> }
                                )}
                            </ButtonCinestar>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default hocOrderStepsHeader(OrderStepsHeader)
